<template>
    <span class="chats-counter__counter-group">
        <i class="fal fa-comment chats-counter__counter-icon chats-counter__counter-icon_comments"
           :class="{'new-only': onlyNewMessages}"></i>
        <span
                class="chats-counter__counter"
                :class="{'new-only': onlyNewMessages}"
        >{{ totalMessagesCount }}</span>
        <span class="chats-counter__new-counter"
              v-if="unreadMessagesCount&&!onlyNewMessages"
        >(+{{ unreadMessagesCount }})</span>
    </span>
</template>

<script>
    export default {
        name: "ChatsListNewMessagesCounter",
        props: {
            totalMessagesCount: Number,
            unreadMessagesCount: Number,
        },
        computed: {
            onlyNewMessages() {
                return this.totalMessagesCount && (this.totalMessagesCount === this.unreadMessagesCount);
            },
        }
    };
</script>

<style scoped lang="scss">
  @import "../../../styles/const";

  .chats-counter {
    &__counter-group {
      //margin-right: 5px;
    }

    &__new-counter {
      vertical-align: middle;
      color: $grass-green;
      position: relative;
      left: -3px;

      font-size: 18px;
      line-height: 25px;
      @media (min-width: 501px) {
        font-size: 23px;
        line-height: 30px;
      }
    }

    &__counter-icon {
      vertical-align: middle;

      &.new-only {
        color: $grass-green;
      }

      &_comments {
        font-size: 20px;
        line-height: 25px;
        @media (min-width: 501px) {
          font-size: 23px;
          line-height: 30px;
        }
      }
    }

    &__counter {
      vertical-align: middle;
      position: relative;
      left: -2px;

      font-size: 18px;
      line-height: 25px;
      @media (min-width: 501px) {
        font-size: 23px;
        line-height: 30px;
      }

      &.new-only {
        color: $grass-green;
      }
    }
  }
</style>